import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-status-intimacoes',
  templateUrl: './status-intimacoes.component.html',
  styleUrls: ['./status-intimacoes.component.scss']
})
export class StatusIntimacoesComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
